import React from 'react';
import { translate } from '../translations';
import { getTheme } from '../Theme';

import projectUE1 from '../images/ue1.png';
import projectUE2 from '../images/ue2.png';
import projectUE3 from '../images/ue3.png';
import projectUE4 from '../images/ue4.png';

const Project = () => {
  return (
    <section id="project">
      <div className={getTheme('ue-title-container')}>
        <div className="container" style={{ marginTop: '40px' }}>
          <h1 className="ue-header">
            {translate('Filipek-Motors Sp. z o.o. realizuje projekt:')}
          </h1>
          <h2 className="ue-title">
            {translate(
              'Zaprojektowanie i badania silników prądu stałego i prądnic LMB'
            )}
            <br />
          </h2>
          <h3 className="ue-title-description">
            {translate('Projekt nr: POIR.01.01.01-00-0245/19')}
            <br />
            {translate(
              'współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego'
            )}
            <br />
            {translate(
              'w ramach ”Programu Operacyjnego Inteligentny Rozwój 2014 – 2020”.'
            )}
            <br />
          </h3>
        </div>
      </div>

      <div className="container">
        <div className={getTheme('ue-img-container')}>
          <img className='ue-img' src={projectUE1} alt={'project'} />
          <img className='ue-img' src={projectUE2} alt={'project'} />
          <a style={{margin:'auto'}} title='https://www.ncbr.gov.pl/' href='https://www.ncbr.gov.pl/'>
            <img className='ue-img' src={projectUE3} alt={'project'} />
          </a>
          <img className='ue-img' src={projectUE4} alt={'project'} />
        </div>
      </div>

      <div className='container'>
        <div className='ue-description'>
          <b>{translate('Projekt dotyczy')}</b>{' '}
          {translate(
            'przeprowadzenia badań przemysłowych związanych z nowym typem silników prądu stałego, opartych na zjawisku oddziaływania przewodnika z prądem na linię międzybiegunową LMB magnesu trwałego, eksperymentalnych prac rozwojowych dla prądnic i silników prądu stałego LMB oraz prac przedwdrożeniowych związanych z przygotowaniem silników i prądnic LMB o ustalonym typoszeregu do produkcji.'
          )}
          <br />
          <b>{translate('Badania przemysłowe')}</b>{' '}
          {translate(
            'pozwolą na określenie zasad dla zjawiska LMB potrzebnych do obliczeń parametrów konstrukcyjnych silników i prądnic LMB, zaprojektowania typoszeregu dla tych urządzeń oraz sporządzenia dokumentacji konstrukcyjnej. Zostaną wykonane modele silników i prądnic LMB oraz przeprowadzone ich badania.'
          )}
          <br />
          <b>{translate('Eksperymentalne prace rozwojowe')}</b>{' '}
          {translate(
            'umożliwią budowę prototypów silników i prądnic LMB, wyznaczenie ich charakterystyk pracy, realizację elektronicznego sterownika i wykonanie testów w warunkach rzeczywistych.'
          )}
          <br />
          <b>{translate('Prace przedwdrożeniowe')}</b>{' '}
          {translate(
            'obejmą certyfikację i testowanie urządzeń LMB oraz przygotują grupę silników i prądnic LMB do produkcji seryjnej.'
          )}
          <br />
          <b>{translate('Silniki LMB')}</b>{' '}
          {translate(
            'mogą być wykorzystywane w transporcie (w pojazdach elektrycznych, modelarstwie (drony), łodziach, rowerach, wózkach inwalidzkich i transporcie wewnątrzzakładowym) oraz jako oddzielne silniki napędowe. Prądnice LMB mogą być stosowane w transporcie jako mini prądnice wiatrowe (energia odnawialna) i generatory energii elektrycznej (alternatory).'
          )}
        </div>

        <div className="ue-info">
          <h3> {translate('Nr projektu:')} &nbsp;</h3>
          <h4> POIR.01.01.01-00-0245/19 </h4>
          <br /> 
          <h3> {translate('Tytuł projektu:')} &nbsp;</h3>
          <h4>
            {translate(
              'Zaprojektowanie i badania silników prądu stałego i prądnic LMB'
            )}
          </h4>
          <br /> 
          <h3> {translate('Okres realizacji:')} &nbsp;</h3>
          <h4>16.01.2020 – 28.09.2022</h4>
          <br />
          <h3> {translate('Całkowita wartość Projektu:')} &nbsp;</h3>
          <h4>1 528 232,35 PLN</h4>
          <br />
          <h3>
            {' '}
            {translate('Dofinansowanie Projektu z Unii Europejskiej:')} &nbsp;
          </h3>
          <h4>1 209 164,12 PLN</h4>
          <br /> <br />
          <h4>
            {translate(
              'Projekt współfinansowany ze środków Europejskiego Funduszu Rozwoju Regionalnego w ramach Programu Operacyjnego Inteligentny Rozwój 2014-2020.'
            )}
          </h4>
          <br /> <br />
        </div>
      </div>
    </section>
  );
};

export default Project;
